import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e428f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "buttonBox" }

import { t } from '@/plugins/i18n'
import { ref, toRef } from 'vue'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  boxdetail: {
    type: Array,
    default: () => { return [] }
  },
  boxdetailcolumns: {
    type: Array,
    default: () => { return [] }
  }
},
  emits: ['update:visible', 'download'],
  setup(__props, { emit: emits }) {

const props = __props



const tabledata = toRef(props, 'boxdetail')
const columns = ref(props.boxdetailcolumns)


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emits('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('装箱明细')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('download'))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('ダウンロード')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(STable, {
        "row-key": "id",
        tableData: _unref(tabledata),
        columns: columns.value,
        showPagination: false
      }, {
        productImg: _withCtx(({ row }) => [
          _createVNode(ShoppingPreview, {
            image: row.productImg
          }, null, 8, ["image"])
        ]),
        productSkuInfo: _withCtx(({ row }) => [
          _createElementVNode("p", null, _toDisplayString(row.productName), 1)
        ]),
        _: 1
      }, 8, ["tableData", "columns"])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})